(() => {
  const connect = (root) => {
    root.querySelectorAll('.militarshop-home-categories__mobile').forEach((mobile) => {
      const scroller = mobile.querySelector('.militarshop-home-categories__mobile-scroll');
      const progress = mobile.querySelector('.militarshop-home-categories__progress');
      if (!scroller || !progress || progress.dataset.connected) return;
      progress.dataset.connected = 'true';

      const maxScroll = () => Math.max(0, scroller.scrollWidth - scroller.clientWidth);
      const update = () => {
        const max = maxScroll();
        progress.value = max ? Math.round(scroller.scrollLeft / max * 100) : 0;
        progress.disabled = max === 0;
      };

      scroller.addEventListener('scroll', update, { passive: true });
      progress.addEventListener('input', () => {
        scroller.scrollLeft = maxScroll() * Number(progress.value) / 100;
      });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => connect(document));
  } else {
    connect(document);
  }
  document.addEventListener('shopify:section:load', (event) => connect(event.target));
})();
